// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {InputBase, TextInput} from 'sail/Input';
import {Table, TableHeaderCell, TableCell} from '../../../../core/Table/Table';
import {InlineCode} from '../../../../core/InlineCode/InlineCode';
import './TaxCodesTable.scss';

type TaxCodeEntryType = {|
  id: string,
  name: string,
  description: string,
|};

type TaxCodesTableProps = {|
  entries: Array<TaxCodeEntryType>,
  children?: React.Node,
|};

export const TaxCodesTable = ({entries}: TaxCodesTableProps) => {
  const [filter, setFilter] = React.useState('');

  if (!entries) {
    return null;
  }

  const filteredEntries = entries.filter((entry) => {
    const filterText = filter.trim().toLowerCase();
    return (
      entry.name.toLowerCase().includes(filterText) ||
      entry.id.toLowerCase().includes(filterText) ||
      entry.description.toLowerCase().includes(filterText)
    );
  });

  return (
    <Box margin={{top: 16}}>
      <Group direction="vertical">
        <InputBase>
          <TextInput
            type="search"
            onChange={setFilter}
            value={filter}
            placeholder={'Search tax codes...'}
            width={300}
          />
        </InputBase>
        <Table type="striped">
          <thead>
            <tr>
              <TableHeaderCell className="TaxCodesTableCellID">
                Tax code
              </TableHeaderCell>
              <TableHeaderCell className="TaxCodesTableCellName">
                Category name
              </TableHeaderCell>
              <TableHeaderCell>Use this tax code for</TableHeaderCell>
            </tr>
          </thead>
          <tbody>
            {filteredEntries.length !== 0 ? (
              filteredEntries.map((entry) => (
                <tr>
                  <TableCell className="TaxCodesTableCellID">
                    <InlineCode>{entry.id}</InlineCode>
                  </TableCell>
                  <TableCell className="TaxCodesTableCellName">
                    {entry.name}
                  </TableCell>
                  <TableCell>{entry.description}</TableCell>
                </tr>
              ))
            ) : (
              <tr>
                <TableCell
                  className="TaxCodesTableCellName"
                  colspan={3}
                >{`No matching tax codes found`}</TableCell>
              </tr>
            )}
          </tbody>
        </Table>
      </Group>
    </Box>
  );
};
